import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, Box } from '@mui/material';
const CategoryDialog = ({ open, onClose, selectedCategory, formik }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{selectedCategory ? "Edit Sub Category" : "Add a Sub Category"}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Enter category name and category code here. Category code can be 8 characters long only.
                </DialogContentText>
                <Box display="flex" flexDirection="column">
                    <TextField
                        variant="standard"
                        name="categoryName"
                        onChange={(e) => {
                            const trimmedValue = e.target.value.replace(/^\s+/, ''); // Trim spaces before any character
                            formik.handleChange(e);
                            formik.setFieldValue('categoryName', trimmedValue);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.categoryName}
                        error={formik.touched.categoryName && Boolean(formik.errors.categoryName)}
                        helperText={formik.touched.categoryName && formik.errors.categoryName}
                        label="Enter category name here"
                    />
                    <TextField
                        variant="standard"
                        label="Enter category code"
                        name="categoryCode"
                        onChange={(e) => {
                            const trimmedValue = e.target.value.replace(/^\s+/, ''); // Trim spaces before any character
                            formik.handleChange(e);
                            formik.setFieldValue('categoryCode', trimmedValue);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.categoryCode}
                        error={formik.touched.categoryCode && Boolean(formik.errors.categoryCode)}
                        helperText={formik.touched.categoryCode && formik.errors.categoryCode}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={formik.handleSubmit} disabled={!formik.isValid || formik.isSubmitting}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CategoryDialog;